const sectionNameConverter = (sectionName) => {
    let convertedSectionName = sectionName
        .split("/n")
        .map((elem) => elem.trim().toUpperCase())
        .join(" ");
    return convertedSectionName;
};

export default sectionNameConverter;
